import type { FaireProductEntity } from "../../entity_types/product";

export const p_f43ya29aav: FaireProductEntity = {
  token: "p_f43ya29aav",
  type: "product",
  name: "Lemon Aperitif (Alcohol Free)",
  brandToken: "b_g593ctghc8",
  brandName: "Abstinence Spirits",
  imageUrl:
    "https://cdn.faire.com/fastly/72e7928a08c545c592c6739896a613f85c1c782df881c94af710d18c1ea3bd24.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1cd8cd1f226d9dcfff1e9e59a9f5ed270b3ce3d3d42ef83808941a1145aa75d7.jpeg",
    "https://cdn.faire.com/fastly/f8ed7855ec3a21bcfe9b3aaa01d50c5be3a1839b3ee849615b752919f9f6681f.jpeg",
    "https://cdn.faire.com/fastly/bf27ef00640824ecd9f40255446e87085826cd921929747015b7905fc96e511e.png",
  ],
  priceDollars: 27.16,
  description:
    "Any great occasion or social gathering necessitates a premium, mouth-watering Aperitif. Abstinence Non-Alcoholic Aperitif provides all the richness and complexity of flavor, without the alcohol. A marriage of zesty Lemon and aromatic Buchu, further complimented by Aloe and African Wormwood. A unique South African spin to a mouth-watering appetizer for a guilt free Spritz or low ABV cocktail. \n\nBotanicals: Buchu, African Wormwood, Aloe, Cinchona Bark, Lemon, Quinine, Spice Distillate\n",
  tags: [],
  msrpDollars: 38.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:52.118Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
